import React from 'react';

import ChevronRight from '@mui/icons-material/ChevronRight';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useSplitExclusionNoticeStyles } from './styles';

type SplitExclusionNoticeProps = {
  onEditSplits: () => void;
};

/**
 * "Exclusion is managed per split." notice shown in place of `ExclusionsButton`
 * once a series has splits assigned — exclusions become a per-split setting
 * at that point. Shared between the Bill Setup flow and the Create/Edit
 * Series dialog.
 */
export default function SplitExclusionNotice({ onEditSplits }: SplitExclusionNoticeProps): React.JSX.Element {
  const { classes } = useSplitExclusionNoticeStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.noticeRow}>
        <InfoOutlined className={classes.noticeIcon} />
        <Typography variant='captionRegular' className={classes.noticeText}>
          Exclusion is managed per split.
        </Typography>
      </Box>
      <Button id='series-edit-splits' onClick={onEditSplits} className={classes.editButton} disableRipple>
        <Typography variant='captionRegular' className={classes.editText}>
          Edit Splits
        </Typography>
        <ChevronRight className={classes.editIcon} />
      </Button>
    </Box>
  );
}
